import request from '../utils/http'

const bankapis = {
    //查询银行列表
    getBankList : query => {
        return request({
            url: '/bank/getBankList',
            method: 'get',
            params:query
        });
    },
     //查看银行详情
     getBankById : query => {
        return request({
            url: '/bank/getBankById',
            method: 'get',
            params: query
        });
    },
     //新增银行
     addBank : query => {
        return request({
            url: '/bank/addBank',
            method: 'post',
            data: query
        });
    },
     //修改银行
     updateBank : query => {
        return request({
            url: '/bank/updateBank',
            method: 'post',
            data: query
        });
    },
      //删除银行
      deleteBank : query => {
        return request({
            url: '/bank/deleteBank',
            method: 'post',
            params: query
        });
    },
     //查询银行网点列表
     getBankSiteList : query => {
        return request({
            url: '/bankSite/getBankSiteList',
            method: 'get',
            params:query
        });
    },
      //查询银行网点列表
      getAreaList : query => {
        return request({
            url: '/bankSite/getAreaList',
            method: 'get',
            params:query
        });
    },
     //查看银行网点详情
     getBankSiteById : query => {
        return request({
            url: '/bankSite/getBankSiteById',
            method: 'get',
            params: query
        });
    },
     //新增银行网点
     addBankSite : query => {
        return request({
            url: '/bankSite/addBankSite',
            method: 'post',
            data: query
        });
    },
     //修改银行网点
     updateBankSite : query => {
        return request({
            url: '/bankSite/updateBankSite',
            method: 'post',
            data: query
        });
    },
      //删除银行网点
      deleteBankSite : query => {
        return request({
            url: '/bankSite/deleteBankSite',
            method: 'post',
            params: query
        });
    },
    //查询银行经理列表
    getDirectorList : query => {
        return request({
            url: '/director/getDirectorList',
            method: 'get',
            params:query
        });
    },
     //查看银行经理详情
     getDirectorById : query => {
        return request({
            url: '/director/getDirectorById',
            method: 'get',
            params: query
        });
    },
     //新增银行经理
     addDirector : query => {
        return request({
            url: '/director/addDirector',
            method: 'post',
            data: query
        });
    },
     //修改银行经理
     updateDirector : query => {
        return request({
            url: '/director/updateDirector',
            method: 'post',
            data: query
        });
    },
      //删除银行经理
      deleteDirector : query => {
        return request({
            url: '/director/deleteDirector',
            method: 'post',
            params: query
        });
    },
      //通过权限查询用户
      getUserListByMenuId : query => {
        return request({
            url: '/user/getUserListByMenuId',
            method: 'get',
            params: query
        });
    },

}


export default bankapis
